import styled, { css } from 'styled-components';

import CollapseArrow from '../CollapseArrow';
import Collapsable from '../Collapsable';

export const StyledCollapsable = styled(Collapsable)`
  margin-bottom: 16px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const StyledButton = styled.button<{isCollapsed: boolean}>`
  position: relative;
  background: transparent;
  width: 100%;
  font-size: 14px;
  font-weight: bold;
  padding-top: 3px;
  text-align: left;
  border-radius: 4px;
  border: 0;
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
  display: flex;
  padding: 10px 12px;
  align-items: flex-start;
  line-height: 1.29;

  &:after {
    content: '';
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.colors.primary};
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    pointer-events: none;
  }


  &:hover {
    color: ${({ theme }) => theme.colors.light};

    &:after {
      border: 2px solid ${({ theme }) => theme.colors.light};      
    }
  }

  &:active:not(:disabled) {
    color: ${({ theme }) => theme.colors.lighter};

    &:after {
      border: 2px solid ${({ theme }) => theme.colors.lighter};
    }
  }

  &:focus-visible, &:focus {
    box-shadow: 0 0 3px 0 ${({ theme }) => theme.colors.lighter};
    outline: 0;

    &:after {
      border-width: 2px;
    }
  }

  &:focus:not(&:focus-visible) {
    box-shadow: none;
  }

  ${({ isCollapsed, theme }) => !isCollapsed && css`
    background-color: ${theme.colors.blue12};
    color: ${theme.colors.light};
    padding: 9px 11px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;

    &:after {
      border: 2px solid ${theme.colors.light};
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }

    &:hover {
      background-color: ${theme.colors.white};
      color: ${theme.colors.light};

      &:after {
        border: solid 1px ${theme.colors.light};
      }
    }

    &:active {
      background-color: ${theme.colors.white};
      color: ${theme.colors.lighter};

      &:after {
        border: solid 1px ${theme.colors.lighter};
      }
    }
  `}
`;

export const StyledContent = styled.div`
  border-radius: 4px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray13};
  border-top: none;
  padding: 24px 16px;
  display: flex;
  flex-flow: wrap;
`;

export const StyledArrow = styled(CollapseArrow)`
  position: relative;
  flex-shrink: 0;
  top: -3px;
  margin-right: 4px;
  margin-bottom: -6px;
`;
